import { classNames } from "src/common/classNames";
import { FixedColState } from "src/components/ReactiveTable/components/ReactiveTable/componentProps";

import * as stylesCommon from "./common.module.less";

/**
 * Вычисляет className для ячейки таблицы на основе информации о фиксированной колонке
 */
export const getCellClassName = (
  fixedInfo?: FixedColState,
): string | undefined =>
  classNames([
    fixedInfo ? stylesCommon.stickyCell : undefined,
    fixedInfo?.side === "left" ? stylesCommon.stickyCellLeft : undefined,
    fixedInfo?.side === "right" ? stylesCommon.stickyCellRight : undefined,
  ]);
